(() => {
  const labels = document.querySelector('[data-begode-insurance-labels]');
  if (!labels) return;
  const translations = JSON.parse(labels.textContent);
  const years = translations.years;
  const translateExact = (selector, source, translated) => {
    document.querySelectorAll(selector).forEach(element => {
      if (element.textContent.trim() === source && translated !== source) element.textContent = translated;
    });
  };
  const apply = () => {
    translateExact('.xcotton-productProtection-detail-header-title', 'What We Offer', translations.heading);
    translateExact('.xcotton-productProtection-detail-header-subtitle', 'Add accident protection offered by Xcotton (partner with AIG).', translations.description);
    document.querySelectorAll('.xcotton-productProtection-detail-content-item').forEach(item => {
    const walker = document.createTreeWalker(item, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const match = node.textContent.trim().match(/^([123]) Years?$/);
      if (match && years[Number(match[1])-1] !== node.textContent.trim()) node.textContent = years[Number(match[1])-1];
    }
    });
  };
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; apply(); });
  });
  observer.observe(document.querySelector('.thb-product-detail') || document.body, {childList:true,subtree:true,characterData:true});
  apply();
})();
